import { render, staticRenderFns } from "./addKsHomeUrl.vue?vue&type=template&id=fecd4fe4&scoped=true"
import script from "./addKsHomeUrl.vue?vue&type=script&lang=js"
export * from "./addKsHomeUrl.vue?vue&type=script&lang=js"
import style0 from "./addKsHomeUrl.vue?vue&type=style&index=0&id=fecd4fe4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecd4fe4",
  null
  
)

export default component.exports